// Action Type definitions
export const BADGES_FETCH = 'BADGES_FETCH';
export const CODER_SINGLE_FETCH = 'CODER_SINGLE_FETCH';
export const CODERS_ATTENDANCE_FETCH = 'CODERS_ATTENDANCE_FETCH';
export const CODERS_BADGES_FETCH = 'CODERS_BADGES_FETCH';
export const CODERS_FETCH = 'CODERS_FETCH';
export const EVENT_FETCH = 'EVENT_FETCH';



/** WEBPACK FOOTER **
 ** ./src/state/actions/action-types.js
 **/